// src/components/StatCard.jsx
import React from "react";
import Sparkline from "./charts/Sparkline";

export default function StatCard({ stat, onClick }) {
  const trendUp = stat.delta > 0;
  const trendFlat = stat.delta === 0;
  return (
    <button type="button" className="stat-card" onClick={onClick}>
      <div className="stat-card-top">
        <div
          className="stat-icon"
          style={{ background: `${stat.color}18`, color: stat.color }}
        >
          <i className={stat.icon} />
        </div>
        {!trendFlat && (
          <span className={`stat-delta ${trendUp ? "up" : "down"}`}>
            <i className={`bi ${trendUp ? "bi-arrow-up-right" : "bi-arrow-down-right"}`} />
            {Math.abs(stat.delta)}%
          </span>
        )}
      </div>
      <div className="stat-label">{stat.title}</div>
      <div className="stat-value">{stat.value.toLocaleString()}</div>
      <div className="stat-sub">{stat.subtitle}</div>
      {stat.spark?.length > 0 && (
        <div className="stat-spark">
          <Sparkline data={stat.spark} color={stat.color} />
        </div>
      )}
    </button>
  );
}